import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { PermissionsService } from '../http/permission.service';

@Injectable()
export class PermissionGuard  {

    constructor(private permissionService: PermissionsService) { }

    public canActivate(route: ActivatedRouteSnapshot) {
        const action = route.data['action'];
        if (!action) {
            return false;
        }
        return this.permissionService.hasPermission(action, route.data['entityId'], route.data['portfolioId']);
    }
}
